module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "apple_si.481ec491.png";